import {
    ContextualMenu,
    ContextualMenuItemType,
    DirectionalHint,
    IContextualMenuItem,
    IContextualMenuListProps,
    IRenderFunction,
    mergeStyles,
} from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import React from 'react';
import { ISemanticStyleHelper } from '../../data-types/styles/ISemanticStyleHelper';
import { SiteHeaderToggleButton } from './base-components/SiteHeaderToggleButton';
import { IUserInfoDisplayProps, UserInfoDisplay } from './base-components/UserInfoDisplay';

export interface IUserMenuProps {
    styleHelper?: ISemanticStyleHelper;
    userInfo?: IUserInfoDisplayProps;
    additionalMenuItems?: IContextualMenuItem[];
    userActionMenuItems: IContextualMenuItem[];
}

export function UserMenu(props: IUserMenuProps) {
    const buttonId = useId('user-menu-button');
    const [isMenuOpen, { toggle: toggleIsMenuOpen, setFalse: closeMenu }] = useBoolean(false);

    const defaultMenuItems: Array<IContextualMenuItem> = [
        { key: 'divider_1', itemType: ContextualMenuItemType.Divider },
        ...props.userActionMenuItems,
    ];

    const menuItems = props.additionalMenuItems ? [...props.additionalMenuItems, ...defaultMenuItems] : defaultMenuItems;

    const handleRenderMenuList = React.useCallback(
        (menuListProps?: IContextualMenuListProps, defaultRender?: IRenderFunction<IContextualMenuListProps>) => {
            return (
                <div>
                    <div className={mergeStyles(props.styleHelper?.siteHeaderStyles.customMenuItemContainer)}>
                        <UserInfoDisplay {...props.userInfo} dataTestId="currentUser" />
                    </div>
                    {defaultRender!(menuListProps)}
                </div>
            );
        },
        [props.userInfo, props.styleHelper?.siteHeaderStyles.customMenuItemContainer]
    );

    return (
        <>
            <SiteHeaderToggleButton
                label="User Account Menu"
                onClick={toggleIsMenuOpen}
                id={buttonId}
                isOpenState={isMenuOpen}
                toggleButtonStyles={props.styleHelper?.siteHeaderStyles.toggleButtonStyles}
                iconStyles={props.styleHelper?.siteHeaderStyles.iconStyles}
            >
                <UserInfoDisplay {...props.userInfo} initialsOrImageOnly />
            </SiteHeaderToggleButton>
            <ContextualMenu
                directionalHint={DirectionalHint.bottomRightEdge}
                gapSpace={-4}
                items={menuItems}
                hidden={!isMenuOpen}
                styles={props.styleHelper?.siteHeaderStyles.contextualMenuStyles}
                target={`#${buttonId}`}
                onRenderMenuList={props.userInfo ? handleRenderMenuList : undefined}
                onDismiss={closeMenu}
            />
        </>
    );
}
